module.exports = __webpack_public_path__ + "static/media/helicopter.254e540f.png";